const actions = document.querySelectorAll('product-form-component button[type="submit"]');
if ('IntersectionObserver' in window && actions.length) {
  const visible = new Set();
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    }
    document.body.classList.toggle('doriante-buy-action-visible', visible.size > 0);
  }, { threshold: 0 });
  for (const action of actions) observer.observe(action);
}
